<template>
  <div class="page-container appstore_wrap">
    <store-header tabs="index" :showDoc="true" :defaultMarket="defaultMarketDomain"></store-header>
    <IndexHeader :disableButton="true"></IndexHeader>
    <RegistInfo v-if="steps != 'auditStore'" @next="handleNext" />
    <AuditStore v-if="steps === 'auditStore'" :endObj="endObj" />
    <div class="footer">
      <Footer :isTheme="true" ></Footer>
    </div>

  </div>
</template>

<script>
import RegistInfo from './components/registinfo';
import AuditStore from './components/auditStore';
import IndexHeader from './components/indexheader';
import Footer from '@/components/Footer/index'
export default {
  name: 'Index',
  components: { RegistInfo, AuditStore, IndexHeader, Footer },
  data() {
    return {
      steps: 'index',
      endObj: {},
      activeShow: '',
      isAn: true
    };
  },
  watch: {
    $route(to) {
      this.steps = 'index';
    }
  },
  methods: {
    handleNext(endObj) {
      this.endObj = endObj;
      this.steps = 'auditStore';
    },
    setActiveStore(store) {
      if (this.activeShow == store) {
        this.activeShow = '';
      } else {
        this.activeShow = store;
      }
    }
  },
  created() {},
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    }
  }
};
</script>

<style lang="scss" scoped>
ol,
ul,
dl {
  margin: 0;
}
.dn-btn {
  margin: 0;
  height: 32px;
  padding: 0 24px;
  font-size: 12px;
  line-height: 30px;
  border-width: 1px;
}
.module-wrap {
  margin-top: 80px;
  background: -webkit-gradient(
    linear,
    0 0,
    0 bottom,
    from(#242627),
    to(#242627)
  );
  position: relative;
  height: 440px;
  .w1920 {
    width: 100%;
    height: 100%;
    background: url("../../assets/images/background.jpg") no-repeat center
      bottom;
    background-size: 1920px auto;
  }
  .w1200 {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
  }
  .slogan {
    padding-top: 155px;
    text-align: center;
    h2 {
      margin-bottom: 10px;
      color: #fff;
      font-size: 36px;
    }
    p {
      margin-bottom: 30px;
      padding: 0 200px;
      font-size: 14px;
      color: #fff;
      line-height: 1.6;
    }
  }
  .join-step-wrap {
    position: absolute;
    left: 10px;
    bottom: -40px;
    z-index: 10;
    width: 1180px;
    height: 80px;
    box-sizing: border-box;
    padding: 40px 40px 0;
    background: #409eff;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
    ul {
      float: left;
      margin-left: 227px;
      border-top: 2px solid #ffffff;
      &:before {
        content: "";
        display: table;
      }
      li {
        position: relative;
        top: -20px;
        float: left;
        margin-left: 130px;
        line-height: 40px;
        font-weight: 700;
        font-size: 16px;
        color: #fff;
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
          color: #fff;
          font-size: 13px;
          line-height: 17px;
          font-weight: 400;
          text-align: center;
          border: 1px solid #fff;
          border-radius: 100%;
          font-style: normal;
        }
        span {
          padding: 15px;
          background: #409eff;
        }
      }
      li.first {
        margin-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/Regist.vue